export default __webpack_public_path__ + "static/media/baisaranvalley.22d30f95.jpg";